module.exports = __webpack_public_path__ + "src/modules/home/training/images/1704.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1704.png
// module id = 787
// module chunks = 0